/**
 * RESPONSIBILITY: the statement of faith.
 *
 * Its own section, and its own band, because it is the one part of an About page people
 * arrive looking for and link to directly.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Article } from './rows/article';

@Section({ name: SectionName.AboutFaith, label: 'About · Statement of faith' })
export class AboutFaithSection {
  @Text({ label: 'Title', maxLength: 300, default: 'What we believe' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 2 })
  intro!: string;

  @List({ label: 'Articles', of: () => Article, maxItems: 30 })
  articles!: Article[];

  @Text({
    label: 'Subtitle', maxLength: 120, default: 'What we believe',
    description: 'The small line above the title. Leave empty to leave it off.',
  })
  eyebrow!: string;
}
